<template>
  <v-tooltip
    bottom>
    <template
      v-slot:activator="{ on, attrs }">

      <v-btn
        v-bind="attrs"
        v-on="on"
        :color="color"
        :min-width="minWidth"
        :outlined="outlined"
        :rounded="rounded"
        :text="text"
        elevation="0"
        @click="onRirekiButtonClick">
        デジタコ取込履歴の照会はこちら
        <v-icon>mdi-database-clock-outline</v-icon>
      </v-btn>

    </template>

    <!-- RAW形式で文字列展開 -->
    <span v-html="message"></span>

    <v-dialog max-width="70%" scrollable persistent no-click-animation
      v-bind="computedProps"
      v-on="computedListeners"
      v-model="showDialog">
      <v-card min-height="75%" min-width="70%">
        <v-toolbar elevation="2" color="#2F75B5" dark dense>
          <v-spacer/>
          <v-toolbar-title>
            デジタコ取込履歴
          </v-toolbar-title>
          <v-spacer/>
          <v-btn @click="onCloseClick" text>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid class="px-2 base-area">
            <div class="pa-2">
              <v-row no-gutters>
                <v-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6" :cols="12" class="px-1">
                  <v-row no-gutters>
                    <span class="search-number">{{ filteredRows.length }}</span><span class="mt-2 text-black">件 の検索結果</span>
                    <div class="mt-2" v-if="![undefined, null, ''].includes(searchText)">
                      <span span class="filter-row-text">（</span>
                      <span class="filter-number">{{ filteredRowCount }}</span>
                      <span span class="filter-row-text">件 表示中）</span>
                    </div>
                  </v-row>
                </v-col>
                <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="6" class="mt-2">
                  <span class="text-right-black-bold">さらにフリーワードで絞り込む</span>
                </v-col>
                <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="6" class="px-1">
                  <dd-narrow-down-text-box label="" adjustStyle="padding-top:0px" v-model="searchText"/>
                </v-col>
              </v-row>

              <hr class="section-line mb-2">

              <v-row no-gutters justify="end">
                <v-col :cols="6" class="d-sm-block" />
                <v-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6" :cols="12">
                  <v-row no-gutters justify="end">
                    <dd-select-items-per-page
                      ref="pagination1"
                      :itemsPerPage.sync="itemsPerPage"
                      :currentPage.sync="page"
                      :items="filteredRows"
                      @changeItemsPerPage="changeItemsPerPage"
                      @changePage="changePage"
                    />
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters ref="_calcHeight-Row6">
                <span class="ml-1 view-description" style="color:green;margin-left:20px;font-size: smaller;"><v-icon color="green" small>mdi-information-outline</v-icon>最新50件までデジタコ取込履歴を表示しています。</span>
              </v-row>
              <v-row no-gutters align-content="center">
                <v-col :cols="12">
                  <v-data-table
                    v-model="selectedItem"
                    calculate-widths
                    height="60vh"
                    item-key="id"
                    :headers="headers"
                    :items="filteredRows"
                    :search="searchText"
                    :loading="loading"
                    :header-props="{sortByText: '並び替え'}"
                    loading-text="検索中のため、少々お待ちください。"
                    :itemsPerPage=50
                    fixed-header
                    locale="ja-jp"
                    no-data-text="利用可能なデータはありません。"
                    dense
                    hide-default-footer
                    :page.sync ="page"
                  />
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters class="px-1 py-0 mt-3">
            <dd-transparent-button :minWidth="120" @click="onCloseClick">
              <v-icon color="#1F2B38">mdi-close-circle</v-icon>ヘルプを閉じる
            </dd-transparent-button>
            <v-spacer />
            <dd-select-items-per-page
              ref="pagination2"
              :itemsPerPage.sync="itemsPerPage"
              :currentPage.sync="page"
              :items="filteredRows"
              @changeItemsPerPage="changeItemsPerPage"
              @changePage="changePage"
            />
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-tooltip>
</template>
<script>
/**
 * @file DDv2用ツールチップ付きアイコンボタン
 * @namespace components
 */

/**
 * @vue-prop {String} [message=''] - ツールチップメッセージ
 * @vue-prop {String} [icon=''] - アイコン指定
 * @vue-event {Element} click - クリックイベント
 * @see https://vuetifyjs.com/ja/api/v-icon/
 * @see https://vuetifyjs.com/ja/api/v-tooltip/
 * @description message引数はRAW形式で、タグの挿入を許可しているため、指定する際は注意すること
 * @example
 *   <dd-icon-button-with-tooltip
        v-if="item.delFlg == false"
        message="この行のコピーを作成します"
        icon="mdi-content-copy"
        @click="copyMeisaiRow(item)"/>
 */
import flowMixin from '@/mixins/flowMixins'
import controls from '@/rahmen/controls'
import filter from '@/rahmen/utils/filters'
// import indexeddb from '@/ddv2.library/indexeddb'
import { mapGetters } from 'vuex'

import DdTransparentButton from '@/components/DdTransparentButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdSelectItemsPerPage from '@/components/DdSelectItemsPerPage'

export default {
  mixins: [flowMixin],
  name: 'DdDigitakoRirekiSearchButton',
  components: {
    DdTransparentButton,
    DdNarrowDownTextBox,
    DdSelectItemsPerPage
  },
  props: {
    message: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'primary'
    },
    minWidth: {
      type: Number,
      default: 80
    },
    outlined: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: true
    },
    text: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    conditions: {},
    // フィルター定義 －－ここまで－－
    searchText: '',
    ctypes: controls,
    // 拡張パネル
    /**
     * 一覧内容
     */
    showDialog: false,
    rows: [],
    loading: false,
    // 一覧制御用
    selectedItem: [],
    itemsPerPage: 50,
    page: 1
    /*
     *
     */
  }),
  created () {
    console.log('screen created')
  },
  mounted () {
    this.initialize()
  },
  watch: {
    showDialog: function (n) {
      if (n === true) {
        this.initBindVariables()
        this.onSearchButtonClick()
      }
    }
  },
  computed: {
    ...mapGetters({
    }),
    filteredRows () {
      const self = this
      return self.rows.map((elem) => {
        elem.operationStartDatetimeDisp = elem.operationStartDatetime ? filter.dateYmdHmsFormatter(elem.operationStartDatetime) : ''
        elem.minUnkoStartDisp = elem.minUnkoStart ? filter.dateFormatter(elem.minUnkoStart) : ''
        elem.maxUnkoEndDisp = elem.maxUnkoEnd ? filter.dateFormatter(elem.maxUnkoEnd) : ''
        elem.digitakoUnkoIdFromTo = elem.minDigitakoUnkoId && elem.maxDigitakoUnkoId ? elem.minDigitakoUnkoId + ' ~ ' + elem.maxDigitakoUnkoId : elem.minDigitakoUnkoId ? elem.minDigitakoUnkoId : elem.maxDigitakoUnkoId ? elem.maxDigitakoUnkoId : ''
        return elem
      })
    },
    computedProps () {
      return {
        ...this.$props,
        persistent: true,
        noClickAnimation: true,
        maxWidth: '85%'
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    }
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: [],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('ThKoteiKamotsuNoSearchDialog.defineHeaderPromise')
            self.headers = [
              { text: 'ID', value: 'id', align: ' d-none' },
              { text: '取込実施日時', value: 'operationStartDatetimeDisp' },
              { text: '取込実施者', value: 'jininNmSei' },
              { text: '運行開始日', value: 'minUnkoStartDisp' },
              { text: '運行終了日', value: 'maxUnkoEndDisp' },
              { text: 'デジタコ運行ID', value: 'digitakoUnkoIdFromTo' }
            ]
            resolve()
          })
        },
        initializeInputPromise: (c) => {
          this.initBindVariables()
        },
        savedInputRestorePromise: (c) => {
          console.log('savedInputRestorePromise')
          // ユーザ保存項目の復元
          return new Promise(resolve => {
            this.loadFromCache()
              .then((c) => {
                console.log('ThKoteiKamotsuNoSearchDialog.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        settingViewScroll: () => {
          return true
        },
        researchPromise: (c) => {
          console.log('ThKoteiKamotsuNoSearchDialog.researchPromise', c)
          return new Promise(resolve => {
            this.conditions = c.cache.value.conditions || {}
            this.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('ThKoteiKamotsuNoSearchDialog.restoreViewPromise', c)
          return new Promise(resolve => {
            this.conditions = c.cache.value.conditions || {}
            this.searchText = c.cache.value.searchText || ''
            this.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('ThKoteiKamotsuNoSearchDialog.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            resolve()
          })
        },
        settingLoadEffect: function () {
          return true
        }

      }
      this.initializeForViewer(opt)
    },
    onRirekiButtonClick: function (e) {
      this.showDialog = true
    },
    onSearchButtonClick: function (e) {
      const self = this
      self.selectedItem = []
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/D2prmd0800/GetUploadHistory', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      self.search(opt)
    },
    onCloseClick: function (e) {
      /**
       * 無選択クローズ処理
       * @event click
       * @type {Event}
       */
      this.showDialog = false
    },
    searchValidate: function () {
      return true
    },
    // ----------------------------------------------------------------------------------------------------
    // 内部共通関数
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      this.conditions = {
        getRecordsCount: 50
      }
      this.searchText = ''
    },

    // ----------------------------------------------------------------------------------------------------
    // ページ遷移
    // ----------------------------------------------------------------------------------------------------
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      this.itemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    changePage: function (e) {
      this.page = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    }
  }
}
</script>
